var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import styled from "styled-components";
import { ReactTable } from "@irati/ui/src/Table";
import { H3 } from "@irati/ui/src/Headings";
import Pill from "@irati/ui/src/Pill";
import authentication from "@irati/auth";
import { Hr, Card as BaseCard } from "@irati/ui/src/Layout";
import { Para } from "@irati/ui/src/Labels";
import { twoPxShadow } from "@irati/ui/src/global/elevation";
import { injectIntl } from "@irati/utils/lang";
import getPeopleWalletTransactions from "@irati/wallet/apollo/query/PeopleWallet";
import DateFilter from "@irati/ui/src/DateFilter";
import ErrorText from "@irati/ui/src/ErrorText";
import DownloadReport from "../DownloadReport";
import { PeopleColumns } from "../Columns";
import { TableWrapper } from "./styled";
var Flex = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 30px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 30px;\n"])));
var TransactionsPill = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var MarginLeft = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-left: 10px;\n"], ["\n  margin-left: 10px;\n"])));
var FullWidthHr = styled(Hr)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: auto;\n  margin-left: -20px;\n  margin-right: -20px;\n"], ["\n  width: auto;\n  margin-left: -20px;\n  margin-right: -20px;\n"])));
var Card = styled(BaseCard)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding: 20px;\n  ", ";\n  margin-bottom: 30px;\n"], ["\n  padding: 20px;\n  ", ";\n  margin-bottom: 30px;\n"])), twoPxShadow);
var DEFAULT_PAGE = 0;
var LIMIT = 5;
var Transactions = /** @class */ (function (_super) {
    __extends(Transactions, _super);
    function Transactions(props) {
        var _this = _super.call(this, props) || this;
        _this.buildDataAndPages = function (res) {
            var pages = Math.ceil(res.getPeopleWalletTransactions.total / LIMIT);
            _this.setState({ data: res.getPeopleWalletTransactions.results, pages: pages, load: null });
        };
        _this.getTransactions = function (variables) {
            return getPeopleWalletTransactions(variables)
                .then(_this.buildDataAndPages)
                .catch(function () {
                _this.setState({ load: null, data: [] });
            });
        };
        _this.handlePageChange = function (page) {
            var _a = _this.state, userIds = _a.userIds, minDate = _a.minDate, maxDate = _a.maxDate;
            var offset = page * 5;
            var variables = {
                tenantId: authentication.userTenant().uuid,
                limit: LIMIT,
                offset: offset,
                currency: authentication.defaultUserCurrency(),
                userIds: userIds,
                minDate: minDate,
                maxDate: maxDate
            };
            _this.setState({
                page: page,
                offset: offset,
                load: _this.getTransactions(variables)
            });
        };
        _this.handleUpdateDate = function (date) {
            var userIds = _this.state.userIds;
            var minDate = date.from;
            var maxDate = date.to;
            var variables = {
                tenantId: authentication.userTenant().uuid,
                limit: LIMIT,
                currency: authentication.defaultUserCurrency(),
                userIds: userIds,
                minDate: minDate,
                maxDate: maxDate
            };
            _this.setState({
                minDate: minDate,
                maxDate: maxDate,
                page: 0,
                offset: 0,
                load: _this.getTransactions(variables)
            });
        };
        _this.handleUpdateUsers = function (users) {
            var _a = _this.state, minDate = _a.minDate, maxDate = _a.maxDate;
            var userIds = users.join(",");
            var variables = {
                tenantId: authentication.userTenant().uuid,
                limit: 5,
                currency: authentication.defaultUserCurrency(),
                userIds: userIds,
                minDate: minDate,
                maxDate: maxDate
            };
            _this.setState({
                page: 0,
                offset: 0,
                userIds: userIds,
                load: _this.getTransactions(variables)
            });
        };
        var variables = {
            tenantId: authentication.userTenant().uuid,
            limit: LIMIT,
            currency: authentication.defaultUserCurrency()
        };
        _this.state = {
            load: _this.getTransactions(variables),
            page: DEFAULT_PAGE,
            offset: DEFAULT_PAGE + 1,
            data: [],
            userIds: null,
            minDate: null,
            maxDate: null,
            pages: null
        };
        return _this;
    }
    Transactions.prototype.render = function () {
        var formatMessage = this.props.formatMessage;
        var total = 125;
        var _a = this.state, data = _a.data, pages = _a.pages, page = _a.page, minDate = _a.minDate, maxDate = _a.maxDate, userIds = _a.userIds, load = _a.load;
        return (React.createElement("div", null,
            React.createElement(Card, null,
                React.createElement(DateFilter, { name: "admin.reportingV2.wallet.filterByDate.label", onChange: this.handleUpdateDate })),
            React.createElement(Card, null,
                React.createElement(Flex, null,
                    React.createElement(TransactionsPill, null,
                        React.createElement(H3, null, formatMessage({ id: "admin.reportingV2.wallet.peopleTransactions.title" })),
                        React.createElement(MarginLeft, null,
                            React.createElement(Pill, { text: formatMessage({ id: "admin.reportingV2.wallet.peopleTransactions.pill" }, { total: total }) }))),
                    React.createElement(DownloadReport, { reportType: "wallet-people", from: minDate, to: maxDate, userUuids: userIds && userIds.split(","), orderByAmountDesc: true })),
                React.createElement(FullWidthHr, null),
                React.createElement(Para, null, formatMessage({ id: "admin.reportingV2.wallet.transactions.emptyTransactions" })),
                React.createElement(TableWrapper, null,
                    React.createElement(ReactTable, { id: "peopleTable", data: data, pages: pages, page: page, loading: load, columns: PeopleColumns({ formatMessage: formatMessage, updateUsers: this.handleUpdateUsers }), onPageChange: this.handlePageChange, getPaginationProps: function (allProps) { return (__assign(__assign({}, allProps), { shouldScrollOnUpdate: false })); } })),
                !load && data.length <= 0 && React.createElement(ErrorText, null, formatMessage({ id: "admin.reportingV2.wallet.transactions.emptyData" })))));
    };
    return Transactions;
}(Component));
export default injectIntl(Transactions);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
